'use client';
import NextTopLoader from 'nextjs-toploader';

export default function LoadingBar() {
  return <NextTopLoader height={3} color='hsl(var(--sidebar-ring))' />;
}
